import { defineStore } from 'pinia'
import { local } from '@/utils/storage'

export const loginStore = defineStore('loginStore', {
  state: () => {
    return {
      tenant: '',
      token: '',
      //  登录后是否显示设置密码的弹窗状态
      ignorePwd: null,
      isPwd: null,
      //  微信扫码登录信息
      getQrcode: {},
      // 验证码和帐号登录信息绑定微信信息
      loginMsg: {},
      user: {},
      teamMessage: {},
      buyPoints: '',
      invite: ''
    }
  },
  getters: {
    getSelectIndex() {
      return this.tagList.findIndex((i) => i.id === this.selectTag.id)
    }
  },
  //可以操作异步 和 同步提交state
  actions: {
    setToken(value) {
      // console.log('value setToken', value)
      local.set('TOKEN', value)
      this.token = value
    },
    setUser(value) {
      local.set('USER', value)
      this.user = value
    },
    setPwd(value) {
      local.set('isPwd', value)
      this.isPwd = value
    },
    setIgnorePwd(value) {
      local.set('ignorePwd', value)
      this.ignorePwd = value
    },
    setTenant(value) {
      local.set('TENANT', value)
      this.isPwd = value
    },
    setTeamMessage(value) {
      local.set('teamMessage', value)
      this.teamMessage = value
    },
    setBuyPoints(value) {
      this.buyPoints = value
    }
  }
})
